import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import 'swiper/css/free-mode';
import './productspage.css';

Modal.setAppElement('#root');

const ProductsPage = () => {
  const [activeCategory, setActiveCategory] = useState('All Categories');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const navigate = useNavigate();
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 16;

 
const productsData = {
  "Safety Gear & PPE": [
    {
      id: "sg-001",
      name: "Helmet",
      description: "Industrial-grade safety helmet with adjustable headband and ventilation. Meets ANSI Z89.1 standards.",
      images: ["helmet1.jpg", "helmet2.jpg", "helmet3.jpg", "helmet4.jpg"],
      features: ["Impact resistant", "UV protection", "Adjustable fit", "6-point suspension"]
    },
    {
      id: "sg-002",
      name: "Reflective Jacket",
      description: "High-visibility reflective jacket for maximum safety in low-light conditions.",
      images: ["jacket1.jpg", "jacket2.jpg", "jacket3.jpg"],
      features: ["ANSI Class 3 certified", "Water-resistant", "Multiple pockets", "Breathable fabric"]
    },
    {
      id: "sg-003",
      name: "Safety Glasses",
      description: "Clear anti-fog safety glasses with UV protection and side shields.",
      images: ["glasses1.jpg", "glasses2.jpg"],
      features: ["ANSI Z87.1 certified", "Scratch-resistant", "Comfort fit", "UV400 protection"]
    },
    {
      id: "sg-004",
      name: "Welding Goggles",
      description: "Professional welding goggles with adjustable headband and shade #5 lens.",
      images: ["goggles1.jpg", "goggles2.jpg", "goggles3.jpg"],
      features: ["Auto-darkening lens", "Comfortable fit", "UV/IR protection", "Durable frame"]
    },
    {
      id: "sg-005",
      name: "Safety Boots",
      description: "Steel-toe work boots with slip-resistant soles and electrical hazard protection.",
      images: ["boots1.jpg", "boots2.jpg", "boots3.jpg", "boots4.jpg"],
      features: ["ASTM F2413-18 compliant", "Waterproof", "Composite toe", "Anti-fatigue technology"]
    },
    {
      id: "sg-006",
      name: "Rain Boots",
      description: "Heavy-duty rubber rain boots for wet working conditions.",
      images: ["rainboots1.jpg", "rainboots2.jpg"],
      features: ["100% waterproof", "Knee-high design", "Non-slip sole", "Reinforced toe"]
    },
    {
      id: "sg-007",
      name: "Coverall",
      description: "Durable work coverall with multiple pockets and reinforced stitching.",
      images: ["coverall1.jpg", "coverall2.jpg", "coverall3.jpg"],
      features: ["Fire-resistant option", "Multiple sizes", "Breathable fabric", "Utility pockets"]
    },
    {
      id: "sg-008",
      name: "Raincoat",
      description: "High-visibility waterproof raincoat with sealed seams.",
      images: ["raincoat1.jpg", "raincoat2.jpg"],
      features: ["PVC material", "Reflective stripes", "Adjustable hood", "Storm flap"]
    },
    {
      id: "sg-009",
      name: "Hand Gloves",
      description: "Cut-resistant work gloves with enhanced grip and dexterity.",
      images: ["gloves1.jpg", "gloves2.jpg", "gloves3.jpg"],
      features: ["ANSI Cut Level A4", "Breathable", "Abrasion resistant", "Touchscreen compatible"]
    }
  ],
  "Construction Tools & Hardware": [
    {
      id: "ct-001",
      name: "Hammer",
      description: "16oz curved claw hammer with fiberglass handle.",
      images: ["hammer1.jpg", "hammer2.jpg"],
      features: ["Forged steel head", "Shock-absorbing grip", "Milled face", "Balanced design"]
    },
    {
      id: "ct-002",
      name: "Lb Hammer",
      description: "3lb drilling hammer with hickory handle.",
      images: ["lbhammer1.jpg", "lbhammer2.jpg"],
      features: ["Drop-forged head", "Heavy-duty", "Versatile use", "Durable construction"]
    },
    {
      id: "ct-003",
      name: "Screwdriver",
      description: "6-piece screwdriver set with magnetic tips.",
      images: ["screwdriver1.jpg", "screwdriver2.jpg"],
      features: ["Rubberized grip", "Cr-v steel", "Precision tips", "Lifetime warranty"]
    },
    {
      id: "ct-004",
      name: "Chisel",
      description: "1-inch wood chisel with hardened steel blade.",
      images: ["chisel1.jpg", "chisel2.jpg"],
      features: ["High-carbon steel", "Shock-resistant handle", "Beveled edge", "Durable construction"]
    },
    {
      id: "ct-005",
      name: "Set Chisel",
      description: "4-piece wood chisel set in storage roll.",
      images: ["setchisel1.jpg", "setchisel2.jpg"],
      features: ["Multiple sizes", "Leather storage roll", "Hardened steel", "Ergonomic handles"]
    },
    {
      id: "ct-006",
      name: "Crow Bar",
      description: "24-inch forged steel crow bar with ergonomic grip.",
      images: ["crowbar1.jpg", "crowbar2.jpg"],
      features: ["Pry bar", "Nail puller", "Demolition tool", "Heavy-duty"]
    },
    {
      id: "ct-007",
      name: "Cutlass",
      description: "Agricultural cutlass with hardwood handle.",
      images: ["cutlass1.jpg", "cutlass2.jpg"],
      features: ["Carbon steel blade", "Durable handle", "Bush clearing", "Farm tool"]
    },
    {
      id: "ct-008",
      name: "Sickle",
      description: "Traditional harvesting sickle with curved blade.",
      images: ["sickle1.jpg", "sickle2.jpg"],
      features: ["Sharp blade", "Wooden handle", "Agricultural use", "Harvesting tool"]
    },
    {
      id: "ct-009",
      name: "Trimming Knife",
      description: "Professional trimming knife with replaceable blades.",
      images: ["trimknife1.jpg", "trimknife2.jpg"],
      features: ["Retractable blade", "Comfort grip", "Blade storage", "Versatile use"]
    },
    {
      id: "ct-010",
      name: "Jack Plane (04 & 05)",
      description: "Woodworking bench plane for smoothing and finishing.",
      images: ["jackplane1.jpg", "jackplane2.jpg"],
      features: ["High-carbon blade", "Adjustable mouth", "Rosewood handles", "Precision machining"]
    },
    {
      id: "ct-011",
      name: "Allen Key",
      description: "9-piece metric allen key set in holder.",
      images: ["allenkey1.jpg", "allenkey2.jpg"],
      features: ["Cr-v steel", "Color-coded", "Compact holder", "Lifetime warranty"]
    },
    {
      id: "ct-012",
      name: "Trowel",
      description: "Masonry trowel with hardwood handle.",
      images: ["trowel1.jpg", "trowel2.jpg"],
      features: ["Carbon steel blade", "Durable handle", "Brick laying", "Concrete work"]
    },
    {
      id: "ct-013",
      name: "Headpan",
      description: "Heavy-duty steel headpan for construction materials.",
      images: ["headpan1.jpg", "headpan2.jpg"],
      features: ["Galvanized steel", "Reinforced rim", "Durable construction", "Multi-purpose"]
    },
    {
      id: "ct-014",
      name: "Shovel",
      description: "Round-point shovel with fiberglass handle.",
      images: ["shovel1.jpg", "shovel2.jpg"],
      features: ["Tempered steel", "Ergonomic grip", "Durable", "Digging tool"]
    },
    {
      id: "ct-015",
      name: "Rake",
      description: "24-tine bow rake with steel head.",
      images: ["rake1.jpg", "rake2.jpg"],
      features: ["Steel tines", "Wood handle", "Garden tool", "Leveling"]
    },
    {
      id: "ct-016",
      name: "Scrapper",
      description: "4-inch putty scraper with replaceable blades.",
      images: ["scraper1.jpg", "scraper2.jpg"],
      features: ["Stainless steel", "Comfort grip", "Versatile", "Paint removal"]
    },
    {
      id: "ct-017",
      name: "Measuring Tape",
      description: "25ft retractable tape measure with magnetic tip.",
      images: ["tape1.jpg", "tape2.jpg"],
      features: ["Dual scale", "Impact-resistant case", "Magnetic tip", "Belt clip"]
    },
    {
      id: "ct-018",
      name: "Measuring Scale",
      description: "Digital measuring scale with LCD display.",
      images: ["scale1.jpg", "scale2.jpg"],
      features: ["500kg capacity", "Precision sensors", "Auto power-off", "Battery included"]
    },
    {
      id: "ct-019",
      name: "Whit Tape",
      description: "1-inch white marking tape for construction.",
      images: ["whittape1.jpg"],
      features: ["Non-residue", "Easy tear", "Bright white", "100ft roll"]
    },
    {
      id: "ct-020",
      name: "Org Saw File",
      description: "Triangular saw file for sharpening teeth.",
      images: ["sawfile1.jpg"],
      features: ["High-carbon steel", "Precision cut", "Long-lasting", "Hand tool"]
    },
    {
      id: "ct-021",
      name: "Org Pliers",
      description: "8-inch combination pliers with wire cutter.",
      images: ["pliers1.jpg", "pliers2.jpg"],
      features: ["Cr-v steel", "Comfort grips", "Wire cutter", "Multi-purpose"]
    },
    {
      id: "ct-022",
      name: "Screw Bits",
      description: "50-piece screw bit set with magnetic holder.",
      images: ["bits1.jpg", "bits2.jpg"],
      features: ["Multiple types", "Magnetic holder", "Cr-mo steel", "Comprehensive set"]
    },
    {
      id: "ct-023",
      name: "Boit Cutters (All Sizes)",
      description: "Heavy-duty bolt cutters for hardened materials.",
      images: ["boltcutter1.jpg", "boltcutter2.jpg"],
      features: ["Compound leverage", "Heat-treated blades", "Non-slip grips", "Multiple sizes"]
    },
    {
      id: "ct-024",
      name: "Top Cutters (All Sizes)",
      description: "Diagonal cutting pliers for electrical work.",
      images: ["topcutter1.jpg", "topcutter2.jpg"],
      features: ["Insulated handles", "Precision ground", "Cutting capacity", "Durable"]
    }
  ],
  "Cutting & Blades": [
    {
      id: "cb-001",
      name: "Sandflex Blade",
      description: "Masonry cutting blade for angle grinders.",
      images: ["sandflex1.jpg", "sandflex2.jpg"],
      features: ["4.5 inch diameter", "Fast cutting", "Long life", "Concrete/masonry"]
    },
    {
      id: "cb-002",
      name: "G.Man Blade",
      description: "Professional-grade cutting blade for various materials.",
      images: ["gman1.jpg", "gman2.jpg"],
      features: ["Multi-material", "Precision cut", "Durable", "Fast cutting"]
    },
    {
      id: "cb-003",
      name: "Cut Brick Blade",
      description: "Diamond blade specifically designed for brick cutting.",
      images: ["brickblade1.jpg", "brickblade2.jpg"],
      features: ["Wet/dry use", "Long lifespan", "Clean cuts", "7 inch diameter"]
    },
    {
      id: "cb-004",
      name: "Diamond Cutter",
      description: "Premium diamond blade for hard materials.",
      images: ["diamond1.jpg", "diamond2.jpg"],
      features: ["Industrial grade", "Continuous rim", "Concrete/tile", "10 inch"]
    },
    {
      id: "cb-005",
      name: "Marble Cutter",
      description: "Specialized blade for marble and granite cutting.",
      images: ["marble1.jpg", "marble2.jpg"],
      features: ["Smooth finish", "Turbo segments", "Wet cutting", "7 inch diameter"]
    }
  ],
  "Painting & Finishing Tools": [
    {
      id: "pf-001",
      name: "Paint Brush",
      description: "High-quality paint brush with natural bristles.",
      images: ["paintbrush1.jpg", "paintbrush2.jpg"],
      features: ["Natural bristles", "Wood handle", "Smooth finish", "Oil-based paints"]
    },
    {
      id: "pf-002",
      name: "4×14 Paint Brush",
      description: "Wide paint brush for large surface coverage.",
      images: ["widebrush1.jpg", "widebrush2.jpg"],
      features: ["4 inch width", "Stainless steel ferrule", "Comfort grip", "Synthetic bristles"]
    },
    {
      id: "pf-003",
      name: "Artist Brush",
      description: "Fine detail artist brush set for precision work.",
      images: ["artist1.jpg", "artist2.jpg"],
      features: ["5-piece set", "Fine tips", "Detail work", "Acrylic/oil"]
    },
    {
      id: "pf-004",
      name: "Cup Brush",
      description: "Steel wire cup brush for angle grinders.",
      images: ["cupbrush1.jpg", "cupbrush2.jpg"],
      features: ["4 inch diameter", "Rust removal", "Surface prep", "Heavy-duty"]
    },
    {
      id: "pf-005",
      name: "Iron Roller",
      description: "9-inch paint roller with iron frame.",
      images: ["ironroller1.jpg"],
      features: ["Metal frame", "Standard nap", "Smooth finish", "Wall painting"]
    },
    {
      id: "pf-006",
      name: "Plastic Roller",
      description: "Plastic paint roller with comfortable grip.",
      images: ["plasticroller1.jpg"],
      features: ["Lightweight", "Economical", "Easy clean", "Disposable option"]
    },
    {
      id: "pf-007",
      name: "Spray Paints",
      description: "12oz aerosol spray paint in various colors.",
      images: ["spraypaint1.jpg", "spraypaint2.jpg"],
      features: ["Fast drying", "Multiple colors", "Smooth finish", "Rust protection"]
    },
    {
      id: "pf-008",
      name: "Silicon Gun",
      description: "Professional-grade silicone caulk gun.",
      images: ["siliconegun1.jpg", "siliconegun2.jpg"],
      features: ["Drip-free", "Smooth rod", "Comfort grip", "10:1 thrust ratio"]
    },
    {
      id: "pf-009",
      name: "Flash Band (All Sizes)",
      description: "Self-adhesive flashing tape for waterproofing.",
      images: ["flashband1.jpg", "flashband2.jpg"],
      features: ["Waterproof", "UV resistant", "Easy application", "Various widths"]
    },
    {
      id: "pf-010",
      name: "Abro Tape",
      description: "High-strength sealing tape for multiple uses.",
      images: ["abro1.jpg"],
      features: ["Weatherproof", "Strong adhesive", "Tear resistant", "Multi-purpose"]
    }
  ],
  "Cleaning Tools": [
    {
      id: "cl-001",
      name: "Mops",
      description: "Spin mop with bucket and wringer system.",
      images: ["mop1.jpg", "mop2.jpg"],
      features: ["Microfiber head", "360° rotation", "Bucket included", "Adjustable handle"]
    },
    {
      id: "cl-002",
      name: "Broom",
      description: "Sturdy push broom with synthetic bristles.",
      images: ["broom1.jpg", "broom2.jpg"],
      features: ["Wide head", "Durable bristles", "Aluminum handle", "Outdoor/indoor"]
    },
    {
      id: "cl-003",
      name: "Road Brush",
      description: "Heavy-duty road brush for large area cleaning.",
      images: ["roadbrush1.jpg", "roadbrush2.jpg"],
      features: ["Extra stiff bristles", "Metal back", "Long handle", "Commercial grade"]
    },
    {
      id: "cl-004",
      name: "Toilet Brush",
      description: "Sanitary toilet brush with holder.",
      images: ["toiletbrush1.jpg"],
      features: ["Antibacterial", "Durable bristles", "Stand included", "Easy clean"]
    },
    {
      id: "cl-005",
      name: "Scrubbing Brush",
      description: "Heavy-duty scrubbing brush with wooden handle.",
      images: ["scrubbrush1.jpg"],
      features: ["Stiff bristles", "Ergonomic handle", "Concrete/tile", "Outdoor use"]
    },
    {
      id: "cl-006",
      name: "Wire Brush",
      description: "Steel wire brush for heavy cleaning tasks.",
      images: ["wirebrush1.jpg", "wirebrush2.jpg"],
      features: ["Carbon steel bristles", "Wood handle", "Rust removal", "Surface prep"]
    },
    {
      id: "cl-007",
      name: "Blue Line",
      description: "Industrial cleaning detergent concentrate.",
      images: ["blueline1.jpg"],
      features: ["Powerful formula", "Multi-surface", "Economical", "5-liter container"]
    }
  ],
  "Construction Accessories": [
    {
      id: "ca-001",
      name: "Rivet Pin",
      description: "Aluminum rivet pins for various applications.",
      images: ["rivet1.jpg"],
      features: ["Multiple sizes", "Aluminum material", "Easy installation", "Pack of 100"]
    },
    {
      id: "ca-002",
      name: "Chains",
      description: "Heavy-duty steel chains for construction use.",
      images: ["chain1.jpg", "chain2.jpg"],
      features: ["Galvanized steel", "Various lengths", "High tensile", "Weather resistant"]
    },
    {
      id: "ca-003",
      name: "Dog Chain",
      description: "Reinforced dog chain for security applications.",
      images: ["dogchain1.jpg"],
      features: ["3/8 inch thickness", "6ft length", "Durable", "Security use"]
    },
    {
      id: "ca-004",
      name: "Padlock",
      description: "Heavy-duty steel padlock with keys.",
      images: ["padlock1.jpg", "padlock2.jpg"],
      features: ["40mm shackle", "Weatherproof", "2 keys", "Anti-pick pins"]
    },
    {
      id: "ca-005",
      name: "Door Engines",
      description: "Heavy-duty door closer mechanism.",
      images: ["doorengine1.jpg", "doorengine2.jpg"],
      features: ["Adjustable closing", "Universal fit", "Durable construction", "Easy install"]
    },
    {
      id: "ca-006",
      name: "Ropes",
      description: "Polypropylene rope for various uses.",
      images: ["rope1.jpg", "rope2.jpg"],
      features: ["3/8 inch diameter", "100ft length", "UV resistant", "Floatable"]
    },
    {
      id: "ca-007",
      name: "Marie Rope",
      description: "Traditional manila rope for construction.",
      images: ["marierope1.jpg"],
      features: ["Natural fiber", "3/4 inch", "50ft length", "High strength"]
    },
    {
      id: "ca-008",
      name: "Spring",
      description: "Assorted springs for various applications.",
      images: ["spring1.jpg"],
      features: ["Multiple sizes", "Steel construction", "Tension springs", "Pack of 12"]
    },
    {
      id: "ca-009",
      name: "Wire",
      description: "Galvanized steel wire for construction.",
      images: ["wire1.jpg"],
      features: ["16 gauge", "100ft roll", "Rust resistant", "Multi-purpose"]
    },
    {
      id: "ca-010",
      name: "Plum",
      description: "Plumb bob for accurate vertical alignment.",
      images: ["plumb1.jpg"],
      features: ["Brass construction", "25ft line", "Pointed tip", "Professional grade"]
    },
    {
      id: "ca-011",
      name: "Small Bow",
      description: "Decorative bow for finishing touches.",
      images: ["bow1.jpg"],
      features: ["6 inch width", "Various colors", "Ribbon material", "Pack of 10"]
    }
  ],
  "Machines": [
    {
      id: "ma-001",
      name: "Drilling Machine",
      description: "Heavy-duty hammer drill with variable speed.",
      images: ["drill1.jpg", "drill2.jpg", "drill3.jpg"],
      features: ["850W motor", "0-3000 RPM", "Hammer function", "Keyless chuck"]
    },
    {
      id: "ma-002",
      name: "Drilling Bits",
      description: "29-piece drill bit set for various materials.",
      images: ["drillbits1.jpg", "drillbits2.jpg"],
      features: ["HSS material", "Size range 1-13mm", "Storage case", "Wood/metal/plastic"]
    },
    {
      id: "ma-003",
      name: "DTM Machines & Blade",
      description: "Diamond tile cutting machine with water system.",
      images: ["dtm1.jpg", "dtm2.jpg", "dtm3.jpg"],
      features: ["800W motor", "Water cooling", "Adjustable guide", "Included blade"]
    }
  ]
};

  const openModal = (product) => {
    setSelectedProduct(product);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setThumbsSwiper(null);
  };
  const addToQuotes = (product) => {
    const quantity = parseInt(prompt('Enter quantity:', '1'));
    if (!quantity || quantity <= 0) {
      alert('Please enter a valid quantity.');
      return;
    }
  
    const storedQuotes = JSON.parse(localStorage.getItem('quotes')) || [];
    const existingItemIndex = storedQuotes.findIndex(item => item.id === product.id);
  
    if (existingItemIndex !== -1) {
      // If already added, just update quantity
      storedQuotes[existingItemIndex].quantity += quantity;
    } else {
      storedQuotes.push({ ...product, quantity });
    }
  
    localStorage.setItem('quotes', JSON.stringify(storedQuotes));
    alert(`${product.name} added to quotes!`);
  };
  

  const filteredProducts = () => {
    const allProducts = searchQuery === ''
      ? activeCategory === 'All Categories'
        ? Object.values(productsData).flat()
        : productsData[activeCategory]
      : (activeCategory === 'All Categories' 
          ? Object.values(productsData).flat()
          : productsData[activeCategory])
          .filter(product =>
            product.name.toLowerCase().includes(searchQuery.toLowerCase())
          );

    const startIndex = (currentPage - 1) * productsPerPage;
    const endIndex = startIndex + productsPerPage;
    return allProducts.slice(startIndex, endIndex);
  };

  const totalPages = () => {
    const total = searchQuery === ''
      ? (activeCategory === 'All Categories'
          ? Object.values(productsData).flat().length
          : productsData[activeCategory].length)
      : (activeCategory === 'All Categories'
          ? Object.values(productsData).flat()
          : productsData[activeCategory])
          .filter(product =>
            product.name.toLowerCase().includes(searchQuery.toLowerCase())
          ).length;

    return Math.ceil(total / productsPerPage);
  };

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
    setSearchQuery('');
    setCurrentPage(1);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  return (
    <div className="products-page">
      <header className="products-header">
        <h1>UB Resources Product Catalog</h1>
        <p>Quality tools and equipment for all your construction and safety needs</p>
      </header>

      <div className="products-container">
        {/* Category Navigation */}
        <div className="category-section">
          <div className="search-container">
            <input
              type="text"
              placeholder="Search products..."
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </div>

          <nav className="category-nav">
            <ul>
              <li
                className={activeCategory === 'All Categories' ? 'active' : ''}
                onClick={() => handleCategoryClick('All Categories')}
              >
                All Categories
              </li>
              {Object.keys(productsData).map(category => (
                <li
                  key={category}
                  className={activeCategory === category ? 'active' : ''}
                  onClick={() => handleCategoryClick(category)}
                >
                  {category}
                </li>
              ))}
            </ul>
          </nav>
        </div>

        {/* Product Grid */}
        <div className="products-grid">
          <h2 className="category-title">{activeCategory}</h2>
          <div className="products-list">
            {filteredProducts().length === 0 ? (
              <div className="no-products-message">
                <p>Product not available. Contact us at <a href="mailto:sales@ubresources.com">sales@ubresources.com</a> in case we have it in stock but it's not updated here.</p>
              </div>
            ) : (
              filteredProducts().map(product => (
                <div key={product.id} className="product-card" onClick={() => openModal(product)}>
                  <div className="product-image-container">
                    <Swiper
                      spaceBetween={10}
                      slidesPerView={1}
                      navigation
                      modules={[Navigation]}
                      className="main-swiper"
                    >
                      {product.images.map((img, index) => (
                        <SwiperSlide key={index}>
                          <img
                            src={`/images/${img}`}
                            alt={`${product.name} ${index + 1}`}
                            className="product-image"
                          />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                  <h3>{product.name}</h3>
                  
                  <button className="quick-view-btn">Quick View</button>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      {/* Pagination */}
      <div className="pagination">
        <button
          onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
        >
          Prev
        </button>

        {Array.from({ length: totalPages() }, (_, index) => (
          <button
            key={index + 1}
            onClick={() => setCurrentPage(index + 1)}
            className={currentPage === index + 1 ? 'active' : ''}
          >
            {index + 1}
          </button>
        ))}

        <button
          onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages()))}
          disabled={currentPage === totalPages()}
        >
          Next
        </button>
      </div>

      {/* Product Detail Modal */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        className="product-modal"
        overlayClassName="product-modal-overlay"
        contentLabel="Product Details"
      >
        {selectedProduct && (
          <div className="modal-content">
            <button className="close-modal" onClick={closeModal}>×</button>
            <div className="modal-product-container">
              <div className="modal-product-images">
                <Swiper
                  spaceBetween={10}
                  navigation={true}
                  thumbs={{ swiper: thumbsSwiper }}
                  modules={[Navigation, Thumbs]}
                  className="main-swiper"
                >
                  {selectedProduct.images.map((img, index) => (
                    <SwiperSlide key={index}>
                      <img
                        src={`/images/${img}`}
                        alt={`${selectedProduct.name} ${index + 1}`}
                        className="modal-product-image"
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
              <div className="modal-product-details">
                <h2>{selectedProduct.name}</h2>
                <div className="product-price">{selectedProduct.price}</div>
                <div className="product-description">
                  <h3>Description</h3>
                  <p>{selectedProduct.description}</p>
                </div>
                <div className="product-features">
                  <h3>Features</h3>
                  <ul>
                    {selectedProduct.features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                </div>
                <div className="product-actions">
                <button className="contact-btn" onClick={() => navigate('/contact')}>Contact Sales</button>
                <button className="quote-btn" onClick={() => navigate('/howtoorder')}>Request Quote</button>
                <button className="add-to-quote-btn" onClick={() => addToQuotes(selectedProduct)}>Add to Quote</button>
                </div>
                <div className="product-contact">
                  <h3>Need Help?</h3>
                  <p>Call us: <a href="tel:+1234567890">+ 234 703 190 1705</a></p>
                  <p>Email: <a href="mailto:sales@ubresources.com">sales@ubresources.com</a></p>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal>

      <footer className="products-footer">
        <p>Need help selecting the right product? Contact our sales team at sales@ubresources.com or call +1 (234) 567-890</p>
      </footer>
    </div>
  );
};

export default ProductsPage;
